// api.ts — typed client for the COD Verifier backend API.
async function request(path, init) {
    const res = await fetch(path, {
        ...init,
        headers: {
            "Content-Type": "application/json",
            ...(init?.headers ?? {}),
        },
    });
    if (!res.ok) {
        const text = await res.text().catch(() => "unknown error");
        throw new Error(`${res.status}: ${text}`);
    }
    if (res.status === 204)
        return undefined;
    return res.json();
}
export const api = {
    me: () => request("/api/v1/auth/me"),
    signout: () => request("/api/v1/auth/signout", { method: "POST" }),
    listIntegrations: () => request("/api/v1/integrations").then((r) => r.integrations),
    disconnectIntegration: (id) => request(`/api/v1/integrations/${id}/disconnect`, { method: "POST" }),
    listOrders: (params) => {
        const qs = new URLSearchParams();
        if (params?.status)
            qs.set("status", params.status);
        if (params?.limit)
            qs.set("limit", String(params.limit));
        return request(`/api/v1/orders?${qs.toString()}`).then((r) => r.orders ?? []);
    },
    getAutoCancel: () => request("/api/v1/auto-cancel/policy"),
    updateAutoCancel: (policy) => request("/api/v1/auto-cancel/policy", {
        method: "PUT",
        body: JSON.stringify(policy),
    }),
    getBilling: () => request("/api/v1/billing/status"),
    joinWaitlist: (email, plan) => request("/api/v1/billing/waitlist", {
        method: "POST",
        body: JSON.stringify({ email, plan }),
    }),
    // Shopify OAuth connect — redirects via AuthKit URL
    startShopifyConnect: (shop) => request(`/v1/oauth/shopify/start`, { method: "POST", body: JSON.stringify({ return_url: "/dashboard", extra: { shop } }) }),
    // WooCommerce ConnectByKey — credentials submitted directly.
    // The response includes webhook_secret once (server-generated, never re-fetchable).
    // The list endpoint only reports webhook_secret_configured (bool) after this.
    connectWooCommerce: (siteUrl, consumerKey, consumerSecret) => request(`/v1/oauth/woocommerce/connect-key`, { method: "POST", body: JSON.stringify({ site_url: siteUrl, consumer_key: consumerKey, consumer_secret: consumerSecret, return_url: "/dashboard" }) }),
    // PrestaShop ConnectByKey — credentials submitted directly.
    // The response includes webhook_secret once (server-generated, never re-fetchable).
    // The list endpoint only reports webhook_secret_configured (bool) after this.
    connectPrestaShop: (siteUrl, apiKey) => request(`/v1/oauth/prestashop/connect-key`, { method: "POST", body: JSON.stringify({ site_url: siteUrl, api_key: apiKey, return_url: "/dashboard" }) }),
};
